var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSettlementArrowLeftDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 7.00001C13.6316 6.99925 13.7621 7.02447 13.8839 7.07424C14.0057 7.124 14.1166 7.19733 14.21 7.29001C14.3037 7.38297 14.3781 7.49357 14.4289 7.61543C14.4797 7.73729 14.5058 7.868 14.5058 8.00001C14.5058 8.13202 14.4797 8.26273 14.4289 8.38459C14.3781 8.50645 14.3037 8.61705 14.21 8.71001L10.9 12L14.08 15.31C14.2663 15.4974 14.3708 15.7508 14.3708 16.015C14.3708 16.2792 14.2663 16.5326 14.08 16.72C13.987 16.8137 13.8764 16.8881 13.7546 16.9389C13.6327 16.9897 13.502 17.0158 13.37 17.0158C13.238 17.0158 13.1073 16.9897 12.9854 16.9389C12.8636 16.8881 12.753 16.8137 12.66 16.72L8.8 12.72C8.61677 12.5331 8.51414 12.2818 8.51414 12.02C8.51414 11.7583 8.61677 11.5069 8.8 11.32L12.8 7.32001C12.8898 7.22308 12.9978 7.14489 13.118 7.08997C13.2381 7.03504 13.368 7.00447 13.5 7.00001Z",
    fill: "#DBDCDF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettlementArrowLeftDisable);
export default __webpack_public_path__ + "static/media/icon_settlement_arrow_left_disable.4d71d833da0d505f50c2fa8bf87ffa60.svg";
export { ForwardRef as ReactComponent };